import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useStyles } from './styles';
import PropTypes from 'prop-types';
import { 
	useSelector,
} from 'react-redux';

// Props passed to this component: weekFilter
const DataRefresh = (prop) => {
	const { weekFilter } = prop;
	const { dataRefreshTimestamp } = useSelector((state) => state.salesReducer);
	const [lastRefreshDate, setLastRefreshDate] = useState('/-/-/');
	const classesName = useStyles();

	// Monitor changes for dataRefreshTimestamp & weekFilter
	useEffect(() => {
		renderDate(dataRefreshTimestamp);
	}, [dataRefreshTimestamp, weekFilter]);

	const renderDate = (datesObj) => {
		// Custom date format
		const dateFormat = new Intl.DateTimeFormat('en-US', {
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			timeZoneName: 'short',
		});

		let date;
		// Check if datesObj is having date type
		if (datesObj && typeof datesObj === 'object') {
			// Here you can define which data you want to display
			switch (weekFilter) {
				case -1:
					date = new Date(datesObj?.weeklyRefreshDt);
					break;
				case 0:
					date = new Date(datesObj?.dailyRefreshDt);
					break;
				case 1:
					date = new Date(datesObj?.dailyRefreshDt);
					break;
				default:
					date = new Date(datesObj?.weeklyRefreshDt);
			}

			const formatted = dateFormat.format(date);
			setLastRefreshDate(formatted);
		} else {
			return null;
		}
	};

	return (
		<Box data-test={'data-refreshed'} className={classesName.dataRefresh}>
			Data refreshed: {lastRefreshDate}
		</Box>
	);
};

DataRefresh.protoTypes = {
	weekFilter: PropTypes.string,
};

export default DataRefresh;
